// window._ = require('lodash')

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
try {
  window.Popper = require('@popperjs/core').default
  window.$ = window.jQuery = require('jquery')

  bootstrap = require('bootstrap')

  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })

  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {html: true})
  })

  // window.bootbox = require('bootbox')
  window.moment = require('moment')
  require('bootstrap-datepicker')
  require('bootstrap-datepicker/js/locales/bootstrap-datepicker.de')
  // require('bootstrap-timepicker')
  require('bootstrap-table')
  // require('bootstrap-table/src/locale/bootstrap-table-de-DE')

  require('select2')
  // require("select2/src/js/select2/translation.js");
} catch (e) {
  console.error(e)
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
